import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
export function MoreTestimonials() {
  const testimonials = [{
    initials: 'CR',
    name: 'Cecilia R.',
    loc: 'San José',
    role: 'MegaPack + Docente Memorable',
    quote: 'El Kit Domingo Sin Ansiedad me cambió el fin de semana. Ya no llego al lunes destruida. Por primera vez en años, el domingo es mío.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: 'Alajuela',
    role: 'Docente de Secundaria del MEP',
    quote: 'Los scripts de WhatsApp para padres difíciles solos ya valen el precio completo. Respondí un reclamo de nota sin activarme emocionalmente por primera vez en mi carrera.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    loc: 'Heredia',
    role: 'Docente de Primaria del MEP',
    quote: 'El plan de 5 días para recuperar control del aula funcionó exactamente como decía. El miércoles ya sentía la diferencia. El viernes el grupo era otro.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    loc: 'Cartago',
    role: 'Docente del MEP',
    quote: 'El tracker de burnout me hizo ver que llevaba semanas en rojo sin saberlo. Eso solo, haberlo visto a tiempo, valió cada colón invertido.'
  }, {
    initials: 'MV',
    name: 'Marcela V.',
    loc: 'Limón',
    role: 'Docente de Secundaria',
    quote: 'Los tomos de comités me salvaron el año. Tenía cuatro activos y ninguno al día. En una semana los organicé todos con las plantillas.'
  }, {
    initials: 'JB',
    name: 'Jorge B.',
    loc: 'Puntarenas',
    role: 'Docente del MEP',
    quote: 'Docente Memorable me recordó por qué elegí esta profesión. Las herramientas de storytelling transformaron mis clases completamente.'
  }];
  return <section className="py-20 px-4 bg-stone-100" data-id="element-213">
      <div className="max-w-6xl mx-auto" data-id="element-214">
        <h2 className="text-3xl md:text-4xl font-black text-center text-stone-900 mb-12" data-id="element-215">
          ❤️ MÁS DOCENTES QUE YA LO TIENEN
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-216">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-stone-200" data-id="element-217">
              <div className="flex items-center gap-4 mb-4" data-id="element-218">
                <div className="w-12 h-12 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center font-bold text-lg flex-shrink-0" data-id="element-219">
                  {t.initials}
                </div>
                <div data-id="element-220">
                  <div className="font-bold text-stone-900" data-id="element-221">{t.name}</div>
                  <div className="text-xs text-stone-500 flex items-center gap-1" data-id="element-222">
                    <MapPin className="w-3 h-3" data-id="element-223" /> {t.loc} | {t.role}
                  </div>
                </div>
              </div>
              <div className="flex text-amber-400 mb-3" data-id="element-224">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-225" />)}
              </div>
              <p className="text-stone-600 italic text-sm leading-relaxed" data-id="element-226">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}